import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // ✅ Ավելացված է
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faMapMarkerAlt, faCircleNotch, faExclamationCircle, 
    faChevronLeft, faTimes, faInfoCircle, faCalendarAlt, faClock, faCheckCircle 
} from '@fortawesome/free-solid-svg-icons';
import { API_BASE } from './apiConfig';

const OrderModal = ({ isOpen, onClose, serviceName, calcData }) => {
    const { t } = useTranslation(); // ✅ i18n հուկ
    const [loadingLocation, setLoadingLocation] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const today = new Date().toISOString().split('T')[0];

    const [formData, setFormData] = useState({ 
        name: '', phone: '', location: '', date: '', time: '', description: ''    
    });

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        
        if (isOpen) {
            const stored = localStorage.getItem('liber_user');
            const userData = stored ? JSON.parse(stored) : null;
            if (userData) {
                setFormData(prev => ({
                    ...prev,
                    name: userData.full_name || '',
                    phone: userData.phone || '',
                    location: userData.address || ''
                }));
            }
        } else {
            setShowErrors(false);
        }
        
        return () => window.removeEventListener('resize', handleResize);
    }, [isOpen]);

    const getTimeSlots = () => {
        const slots = [];
        const now = new Date();
        const isToday = formData.date === today;

        for (let i = 9; i <= 21; i++) {
            const hours = [ `${i}:00`, `${i}:30` ];
            hours.forEach(slot => {
                const [h, m] = slot.split(':');
                const slotTime = new Date();
                slotTime.setHours(parseInt(h), parseInt(m), 0);

                if (isToday) {
                    if (slotTime > now) slots.push(slot); 
                } else {
                    slots.push(slot);
                }
            });
        }
        return slots;
    };

    const availableTimeSlots = getTimeSlots();

    const getLocation = () => {
        if (!navigator.geolocation) return alert(t('gps_not_supported'));
        setLoadingLocation(true);
        navigator.geolocation.getCurrentPosition((pos) => {
            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;
            const link = `https://www.google.com/maps?q=${lat},${lng}`;
            setFormData(prev => ({ ...prev, location: link }));
            setLoadingLocation(false);
        }, () => {
            alert(t('location_fetch_error'));
            setLoadingLocation(false);
        });
    };

const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    console.log("🔘 [OrderModal] handleSubmit Triggered"); // Ստուգում ենք՝ ֆունկցիան աշխատում է, թե ոչ

    if (!formData.name || !formData.phone || !formData.date || !formData.time) {
        setShowErrors(true);
        console.warn("⚠️ Validation failed");
        return;
    }

    setLoadingSubmit(true);

    // 🚀 Հայտնաբերում ենք տվյալները calcData-ից կամ business-ից
    const biz = calcData?.business || {};
    
    // Ստեղծում ենք ուղարկվող օբյեկտը
    const sendData = {
        user_id: JSON.parse(localStorage.getItem('liber_user'))?.id || null,
        service_name: serviceName || t('default_service_name'),
        category_name: calcData?.category_name || 'WASTE',
        customer_name: formData.name,
        customer_phone: formData.phone,
        order_date: formData.date,
        order_time: formData.time,
        location: formData.location || calcData?.location || '',
        message: calcData?.message || `${formData.description || ''} | ${calcData?.details || ''}`,
        
        // --- 📊 ՖԻՔՍՎԱԾ ԹՎԵՐԸ ---
        total_price: Number(calcData?.total_price || calcData?.totalPrice || 0),
        
        // 🚀 ԱՎԵԼԱՑՐՈՒ ԱՅՍ ՏՈՂԸ (other_expenses-ը սա է)
        other_expenses: Number(calcData?.other_expenses || biz.otherExpenses || 0),
        
        // 🚀 ԱՎԵԼԱՑՐՈՒ ԱՅՍ ՏՈՂԸ (wCount-ը սերվերին պետք է այս անունով)
        wCount: Number(calcData?.wCount || biz.workerCount || 0),
        
        truck_price: Number(biz.truckCost || 0),
        truck_quantity: Number(biz.truckQuantity || 0),
        worker_count: Number(biz.workerCount || 0), // Հին սյունակի համար
        requested_vehicles: biz.vehicleSlots || []
    };

    // 🔥 ԱՀԱ ՔՈ ՈՒԶԱԾ ԼՈԳԸ
    console.log("🚀 [FRONT-END SENDING TO API]:", sendData);

    try {
        const response = await fetch(`${API_BASE}/api/orders`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(sendData)
        });

        if (response.ok) {
            console.log("✅ Order created successfully");
            alert(t('order_success_msg'));
            onClose();
        } else {
            const result = await response.json();
            console.error("❌ Server rejected order:", result);
            alert(t('error_label') + ": " + (result.message || t('order_failed_msg')));
        }
    } catch (error) {
        console.error("❌ Submit error:", error);
    } finally {
        setLoadingSubmit(false);
    }
};
 
    if (!isOpen) return null;

    return (
        <div style={st.overlay} onClick={onClose}>
            <div style={{
                ...st.modal, 
                width: isMobile ? '100%' : '460px',
                height: isMobile ? '94%' : 'auto',
                maxHeight: isMobile ? '94%' : '88vh',
                bottom: isMobile ? '0' : 'auto',
                position: isMobile ? 'fixed' : 'relative',
                borderRadius: isMobile ? '30px 30px 0 0' : '25px',
                display: 'flex',
                flexDirection: 'column'
            }} onClick={e => e.stopPropagation()}>
                
                <div style={st.header}>
                    {isMobile && <div style={st.dragHandle}></div>}
                    <div style={st.headerTop}>
                        <button onClick={onClose} style={st.navBtn}>
                            <FontAwesomeIcon icon={faChevronLeft} /> {t('btn_back')}
                        </button>
                        <span style={st.headerTitle}>{t('order_confirmation_title')}</span>
                        <button onClick={onClose} style={st.closeBtn}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                </div>

                <div style={st.body}>
                    {calcData && (calcData.price > 0 || calcData.total_price > 0) && (
                        <div style={st.premiumSummary}>
                            <div style={st.summaryTop}>
                                <span style={st.serviceTag}>{serviceName}</span>
                                <div style={st.priceValue}>{(calcData.total_price || calcData.price).toLocaleString()} ֏</div>
                            </div>
                            <div style={st.goldDivider}></div>
                            <div style={st.calcDetails}>
                                <FontAwesomeIcon icon={faInfoCircle} style={{color: '#c5a059', minWidth: '15px'}} />
                                <span>{calcData.details}</span>
                            </div>
                        </div>
                    )}

                    <div style={st.form}>
                        {showErrors && (
                            <div style={st.errorMsg}>
                                <FontAwesomeIcon icon={faExclamationCircle} /> {t('fill_required_fields')}
                            </div>
                        )}
                        
                        <div style={st.inputBox}>
                            <label style={st.label}>{t('form_full_name')} *</label>
                            <input style={st.input} placeholder={t('placeholder_name')} value={formData.name} onChange={e => setFormData(p => ({...p, name: e.target.value}))} />
                        </div>

                        <div style={st.inputBox}>
                            <label style={st.label}>{t('form_phone')} *</label>
                            <input style={st.input} placeholder="099 000000" type="tel" value={formData.phone} onChange={e => setFormData(p => ({...p, phone: e.target.value}))} />
                        </div>
                        
                        <div style={st.row}>
                            <div style={{...st.inputBox, flex: 1}}>
                                <label style={st.label}><FontAwesomeIcon icon={faCalendarAlt} /> {t('form_date')} *</label>
                                <input type="date" min={today} style={st.input} value={formData.date} onChange={e => setFormData(p => ({...p, date: e.target.value, time: ''}))} />
                            </div>
                            <div style={{...st.inputBox, flex: 1}}>
                                <label style={st.label}><FontAwesomeIcon icon={faClock} /> {t('form_time')} *</label>
                                <select style={st.input} value={formData.time} onChange={e => setFormData(p => ({...p, time: e.target.value}))}>
                                    <option value="">--:--</option>
                                    {availableTimeSlots.map(t => <option key={t} value={t}>{t}</option>)}
                                </select>
                            </div>
                        </div>

                        <div style={st.inputBox}>
                            <label style={st.label}>{t('form_address')}</label>
                            <div style={st.locationWrapper}>
                                <input placeholder={t('placeholder_address')} style={{...st.input, flex: 1, borderRight: 'none', borderRadius: '15px 0 0 15px'}} value={formData.location} onChange={e => setFormData(p => ({...p, location: e.target.value}))} />
                                <button onClick={getLocation} style={st.locationBtn}>
                                    {loadingLocation ? <FontAwesomeIcon icon={faCircleNotch} spin /> : <FontAwesomeIcon icon={faMapMarkerAlt} />}
                                </button>
                            </div>
                        </div>

                        <div style={st.inputBox}>
                            <label style={st.label}>{t('form_notes')}</label>
                            <textarea placeholder={t('placeholder_notes')} style={st.textarea} value={formData.description} onChange={e => setFormData(p => ({...p, description: e.target.value}))} />
                        </div>
                    </div>
                </div>

                <div style={st.footer}>
                    <button onClick={handleSubmit} disabled={loadingSubmit} style={st.confirmBtn}>
                        {loadingSubmit ? <FontAwesomeIcon icon={faCircleNotch} spin /> : (
                            <>{t('btn_confirm_order')} <FontAwesomeIcon icon={faCheckCircle} style={{marginLeft: '8px'}} /></>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

const st = {
    overlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10001, padding: '10px' },
    modal: { background: '#fff', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden' },
    dragHandle: { width: '40px', height: '4px', background: '#e2e8f0', borderRadius: '10px', margin: '10px auto 5px' },
    header: { padding: '10px 20px 15px', background: '#fff', borderBottom: '1px solid #f1f5f9' },
    headerTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    headerTitle: { fontWeight: '800', fontSize: '16px', color: '#0f172a' },
    navBtn: { border: 'none', background: 'none', color: '#c5a059', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' },
    closeBtn: { border: 'none', background: '#f1f5f9', width: '30px', height: '30px', borderRadius: '50%', color: '#64748b', cursor: 'pointer' },
    body: { padding: '15px 25px', overflowY: 'auto', flex: 1, scrollbarWidth: 'thin' },
    premiumSummary: { background: '#0f172a', borderRadius: '20px', padding: '15px 20px', marginBottom: '20px', color: '#fff' },
    summaryTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
    serviceTag: { fontSize: '13px', opacity: 0.8 },
    priceValue: { fontSize: '20px', fontWeight: '900', color: '#c5a059' },
    goldDivider: { height: '1px', background: 'linear-gradient(90deg, transparent, #c5a059, transparent)', marginBottom: '10px' },
    calcDetails: { fontSize: '12px', color: '#94a3b8', lineHeight: '1.4', display: 'flex', gap: '8px' },
    form: { display: 'flex', flexDirection: 'column', gap: '14px' },
    inputBox: { display: 'flex', flexDirection: 'column', gap: '5px' },
    row: { display: 'flex', gap: '12px' },
    label: { fontSize: '10px', fontWeight: '800', color: '#94a3b8', textTransform: 'uppercase' },
    input: { padding: '12px', borderRadius: '12px', border: '1px solid #e2e8f0', background: '#f8fafc', fontSize: '14px', outline: 'none' },
    textarea: { padding: '12px', borderRadius: '12px', border: '1px solid #e2e8f0', height: '60px', background: '#f8fafc', fontSize: '14px', outline: 'none', resize: 'none' },
    locationWrapper: { display: 'flex' },
    locationBtn: { background: '#0f172a', color: '#fff', border: 'none', borderRadius: '0 12px 12px 0', width: '50px', cursor: 'pointer' },
    footer: { padding: '15px 25px 20px', background: '#fff', borderTop: '1px solid #f1f5f9' },
    confirmBtn: { width: '100%', padding: '16px', background: 'linear-gradient(135deg, #c5a059 0%, #e2c285 100%)', color: '#fff', border: 'none', borderRadius: '15px', fontWeight: '900', fontSize: '15px', cursor: 'pointer' },
    errorMsg: { color: '#ef4444', fontSize: '12px', textAlign: 'center', fontWeight: 'bold', background: '#fef2f2', padding: '8px', borderRadius: '10px' }
};

export default OrderModal;